type TextAreaSelectionRangeType = {
    end: number;
    start: number;
};

type InsertTextAtSelectionResultType = {
    cursorPosition: number;
    value: string;
};

export function insertTextAtSelection(
    currentValue: string,
    insertText: string,
    selectionRange: TextAreaSelectionRangeType
): InsertTextAtSelectionResultType {
    const {end, start} = selectionRange;
    const nextValue = currentValue.slice(0, start) + insertText + currentValue.slice(end);
    const cursorPosition = start + insertText.length;

    return {
        cursorPosition,
        value: nextValue,
    };
}

export function getSelectionRangeFromTextArea(textarea: HTMLTextAreaElement): TextAreaSelectionRangeType {
    const start = textarea.selectionStart ?? textarea.value.length;
    const end = textarea.selectionEnd ?? start;

    return {end, start};
}

export function restoreTextAreaCursor(textarea: HTMLTextAreaElement, cursorPosition: number): void {
    textarea.focus();
    textarea.setSelectionRange(cursorPosition, cursorPosition);
}

export type {TextAreaSelectionRangeType};
